export default __webpack_public_path__ + "static/wws-logo-740ca9a13f9d4b7e16fbaf47baab1005.svg";